import { LineChart, BarChart } from "../../v6common/Charts";
import { StatusBadge } from "../../inquiry/Badges";
import { kstShort } from "../../inquiry/view";
import { dayLabel, HOUR_LABELS } from "./format";

export const PERIODS = [7, 30, 90];

export function DailyPanel({ o, days, onDays }) {
    const rows = o.daily_conversations || [];
    return (
        <div className="panel mt">
            <div className="pn-h"><h3>일별 대화량</h3><span className="sp"></span>
                <select className="sel" value={days} onChange={(e) => onDays(+e.target.value)} aria-label="기간">
                    {PERIODS.map((d) => <option key={d} value={d}>지난 {d}일</option>)}
                </select>
            </div>
            <div className="pn"><LineChart values={rows.map((r) => r.count)} labels={rows.map((r) => dayLabel(r.date))} name="대화" /></div>
        </div>
    );
}

export function HourlyPanel({ o }) {
    return (
        <div className="panel">
            <div className="pn-h"><h3>시간대별 사용량</h3><span className="sp"></span><span className="legend"><span><i style={{ background: "var(--pri)" }}></i>대화량</span></span></div>
            <div className="pn"><BarChart values={o.hourly_usage || []} labels={HOUR_LABELS} name="대화" /></div>
        </div>
    );
}

export function AttentionPanel({ items, meta, go }) {
    const open = (id) => go("inquiry", { openId: id });
    return (
        <div className="panel">
            <div className="pn-h"><h3>지금 챙길 문의</h3><span className="hint">미지정 · 안 읽음</span><span className="sp"></span>
                <button className="btn btn-sm" type="button" onClick={() => go("inquiry")}>문의 관리</button>
            </div>
            <div className="pn" style={{ paddingTop: 6 }}>
                <ul className="lst">
                    {items.length ? items.map((q) => (
                        <li key={q.id} role="button" tabIndex={0} onClick={() => open(q.id)}
                            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(q.id); } }}>
                            <StatusBadge status={q.status} meta={meta} />
                            <b>{q.store?.name || "매장 미확인"}</b>
                            <span className="q">{[q.subcategory?.label, q.request_content].filter(Boolean).join(" · ")}</span>
                            <span className="t">{q.is_late && <span className="late">지연</span>}{kstShort(q.created_at)}</span>
                        </li>
                    )) : <li style={{ color: "var(--tx3)", cursor: "default" }}>챙길 문의가 없습니다</li>}
                </ul>
            </div>
        </div>
    );
}
